"use client";

import { Cloud, Database, Shield, TrendingUp } from "lucide-react";
import { Link } from "@/components/common/Link";
import { Card, CardContent, CardHeader, CardTitle, CardDescription } from "@/components/ui/card";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
export default function NosPiliers() {
  const {
    ref: sectionRef,
    isVisible: sectionVisible
  } = useRevealOnScroll({
    once: true,
    threshold: 0.15
  });
  const pillars = [{
    id: 1,
    iconComponent: Cloud,
    title: "Cloud Strategy & Transformation",
    description: "Stratégie hybride, multi-cloud, cloud souverain, modèles opérationnels et gouvernance avancée.",
    path: "/CloudStrategyTransformationPage"
  }, {
    id: 2,
    iconComponent: Database,
    title: "Data & Intelligence Artificielle",
    description: "Plateformes de données, stratégie IA, industrialisation et intelligence artificielle responsable.",
    path: "/DataArtificialIntelligencePage"
  }, {
    id: 3,
    iconComponent: Shield,
    title: "Cybersécurité & Confiance Numérique",
    description: "Sécurité dès la conception, conformité, résilience et souveraineté numérique.",
    path: "/CybersecurityDigitalTrustPage"
  }, {
    id: 4,
    iconComponent: TrendingUp,
    title: "M&A & Création de Valeur",
    description: "Due diligence IT, intégration post-fusion, carve-outs et accélération de la valeur.",
    path: "/MergersAcquisitionsValueCreationPage"
  }];
  return <section ref={sectionRef} className="relative w-full py-24 px-6 bg-background overflow-hidden">
      <div className="max-w-7xl mx-auto">
        <div className={`mb-16 text-center transition-all duration-500 ${sectionVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-4"}`}>
          <h2 className="text-5xl font-bold text-foreground mb-4">
            Nos Piliers
          </h2>
          <p className="text-lg text-muted-foreground max-w-2xl mx-auto">
            Une expertise stratégique dans quatre domaines clés, offrant clarté et valeur dans des environnements complexes.
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-6">
          {pillars.map((pillar, i) => {
          const Icon = pillar.iconComponent;
          const delay = i * 100;
          return <Link key={pillar.id} to={pillar.path} data-index={i} className="block group">
                <Card className={`h-full glass-effect hover-lift cursor-pointer transition-all duration-300 ${sectionVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-4"}`} style={{
              transitionDelay: sectionVisible ? `${delay}ms` : "0ms"
            }}>
                  <CardHeader className="items-center text-center">
                    <div className="mb-4 p-4 rounded-full bg-primary/10 group-hover:bg-primary/20 transition-all duration-300 group-hover:scale-110 group-hover:shadow-[0_0_20px_rgba(59,130,246,0.4)]">
                      <Icon className="size-8 text-primary" />
                    </div>
                    <CardTitle className="text-xl font-semibold text-foreground group-hover:text-foreground transition-colors duration-300">
                      {pillar.title}
                    </CardTitle>
                  </CardHeader>
                  <CardContent>
                    <CardDescription className="text-center text-muted-foreground leading-relaxed">
                      {pillar.description}
                    </CardDescription>
                  </CardContent>
                </Card>
              </Link>;
        })}
        </div>
      </div>
    </section>;
}